<!-- 
	This is the billing page, it uses the dashboard layout in: 
	"./layouts/Dashboard.vue" .
 -->

<template>
	<div>

		<a-row type="flex" :gutter="24">

			<!-- Billing Info Column -->
			<a-col :span="24" :md="24">
				<a-row type="flex" :gutter="24">
					<a-col :span="24" :xl="12" class="mb-24">
						<CardCredit></CardCredit>
					</a-col>
					<a-col :span="12" :xl="6" class="mb-24" v-for="(salary, index) in salaries" :key="index">
						<WidgetSalary :value="salary.value" :prefix="salary.prefix" :icon="salary.icon"
							:title="salary.title" :content="salary.content"></WidgetSalary>
					</a-col>
					<a-col :span="24" class="mb-24">
						<CardPaymentMethods></CardPaymentMethods>
					</a-col>
				</a-row>
			</a-col>
			<!-- / Billing Info Column -->
		</a-row>

		<a-row type="flex" :gutter="24">
			<a-col :span="24" :md="24" class="mb-24">
				<CardBillingInfo></CardBillingInfo>
			</a-col>
		</a-row>

		<a-row type="flex" :gutter="24">

			<!-- Billing Information Column -->
			<a-col :span="24" :md="24" class="mb-24">
				<CardTransactions></CardTransactions>

			</a-col>
			<!-- Billing Information Column -->


			<!-- <a-col :span="24" :md="8" class="mb-24">
				<CardInvoices :data="invoiceData"></CardInvoices>
			</a-col> -->

		</a-row>

	</div>
</template>

<script>

import CardCredit from "../components/Cards/CardCredit"
import WidgetSalary from "../components/Widgets/WidgetSalary"
import CardPaymentMethods from "../components/Cards/CardPaymentMethods"
import CardInvoices from "../components/Cards/CardInvoices"
import CardBillingInfo from "../components/Cards/CardBillingInfo"
import CardTransactions from "../components/Cards/CardTransactions"

import { getUserInfo } from '../utils/user';
export default ({
	components: {
		CardCredit,
		WidgetSalary,
		CardPaymentMethods,
		CardInvoices,
		CardBillingInfo,
		CardTransactions,
	},
	data() {
		return {
			salaries: [
				{
					value: 0,
					prefix: "+$",
					icon: `
										<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
											<g id="bank" transform="translate(0.75 0.75)">
												<path id="Shape" transform="translate(0.707 9.543)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5"/>
												<path id="Path" d="M10.25,0,20.5,9.19H0Z" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5"/>
												<path id="Path-2" data-name="Path" d="M0,.707H20.5" transform="translate(0 19.793)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5"/>
											</g>
										</svg>`,
					title: "余额",
					content: "账户净值",
				},
				{
					value: 0,
					prefix: "+$",
					icon: `
										<img src="images/logos/paypal-logo-2.png" alt="">`,
					title: "保证金",
					content: "可用保证金",
				},
			],

			// "Invoices" list data.
			invoiceData: [
				{
					title: "March, 01, 2021",
					code: "#MS-415646",
					amount: "180",
				},
				{
					title: "February, 12, 2021",
					code: "#RV-126749",
					amount: "250",
				},
				{
					title: "April, 05, 2020",
					code: "#FB-212562",
					amount: "550",
				},
				{
					title: "June, 25, 2019",
					code: "#QW-103578",
					amount: "400",
				},
				{
					title: "March, 03, 2019",
					code: "#AR-803481",
					amount: "700",
				},
			],
		}
	},
	mounted() {
		this.getData();
	},
	methods: {
		getData() {
			getUserInfo().then(data => {
				if (data.code === 0) {
					let digits = data.moneyDigits
					this.salaries[0].value = data.balance / Math.pow(10, digits);
					this.salaries[1].value = data.freeMargin / Math.pow(10, digits);
				}
			})
				.catch(err => {
					console.info("err:", err)
				})
		}
	}

})

</script>

<style lang="scss"></style>